import { Separator } from '@/components/ui/separator';
import { type FC } from 'react';

export const UpdateCardSkeleton: FC = () => {
  return (
    <div className="w-[800px] max-w-full rounded-2xl border border-neutral-200 p-4 space-y-2.5">
      {/* Section 1: Title + Dates */}
      <div className="space-y-1.5">
        <div className="flex items-center gap-2.5">
          <div className="h-5 w-5 rounded-full bg-neutral-100 animate-pulse shrink-0" />
          <div className="h-4 flex-1 rounded bg-neutral-100 animate-pulse" />
          <div className="h-6 w-20 rounded-lg bg-neutral-100 animate-pulse shrink-0" />
          <div className="h-4 w-4 rounded bg-neutral-100 animate-pulse shrink-0" />
        </div>
        <div className="flex gap-3 ml-[30px]">
          <div className="h-3 w-48 rounded bg-neutral-100 animate-pulse" />
          <div className="h-3 w-44 rounded bg-neutral-100 animate-pulse" />
        </div>
      </div>

      <Separator />

      {/* Section 2: Document */}
      <div className="space-y-1.5">
        <div className="h-3 w-32 rounded bg-neutral-100 animate-pulse" />
        <div className="flex gap-2.5">
          <div className="h-6 flex-1 rounded border border-neutral-100 bg-neutral-50 animate-pulse" />
          <div className="h-6 w-20 rounded-lg bg-neutral-100 animate-pulse" />
          <div className="h-6 w-28 rounded-lg bg-neutral-100 animate-pulse" />
          <div className="h-6 w-24 rounded-lg bg-neutral-100 animate-pulse" />
        </div>
      </div>

      <Separator />

      {/* Section 3: Impact Assessment */}
      <div className="space-y-1.5">
        <div className="flex items-center justify-between">
          <div className="h-3 w-32 rounded bg-neutral-100 animate-pulse" />
          <div className="h-6 w-36 rounded-lg bg-neutral-100 animate-pulse" />
        </div>
        <div className="space-y-1">
          <div className="h-3 w-full rounded bg-neutral-100 animate-pulse" />
          <div className="h-3 w-5/6 rounded bg-neutral-100 animate-pulse" />
        </div>
      </div>
    </div>
  );
};
